var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form-input", {
        attrs: {
          id: "input_unit",
          size: "sm",
          disabled: this.$props.isDisabled
        },
        on: { focus: _vm.onFocusInUnits, blur: _vm.onFocusOutUnits },
        model: {
          value: _vm.unitQuery,
          callback: function($$v) {
            _vm.unitQuery = $$v
          },
          expression: "unitQuery"
        }
      }),
      _vm._v(" "),
      _vm.unitsFocus
        ? _c(
            "b-list-group",
            { staticClass: "unit-autocomplete-input" },
            _vm._l(_vm.filteredUnits, function(item, index) {
              return _c(
                "b-list-group-item",
                {
                  key: index,
                  attrs: { button: "" },
                  on: {
                    mousedown: function($event) {
                      return _vm.onClickUnit(item.code)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.getUnitListText(item)) + "\n    "
                  )
                ]
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0b95616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0b95616","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/UnitSelect.vue
// module id = null
// module chunks = 